import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ContentSideBySideCustom,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
} from "../components/Hero";
import { Link, Navigate, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Grid } from "@mui/material";
import { API_URL } from "../actions/auth";
import axios from "axios";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { alertMessage } from "../actions/auth";
import TextField from "@mui/material/TextField";
import Lottie from "react-lottie";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PublishIcon from "@mui/icons-material/Publish";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";

import { FeatureCard } from "../components/Hero";
import { FeatureCardSmall } from "../components/Hero";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import { Collage2, OurProcess, Trust } from "../components/Sections";

export default function Careers() {
  const [vacancies, setVacancies] = useState([]);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    axios.get(API_URL + "get_vacancies").then((res) => {
      setVacancies(res.data);
    });
  }, []);

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [jobName, setJobName] = useState("");
  const [jobLink, setJobLink] = useState("");
  const [experience, setExperience] = useState("");

  const [value, setValue] = React.useState("1");

  const [selectedFile, setSelectedFile] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [jobId, setJobId] = useState("");

  const dispatch = useDispatch();

  function onFileChange(event) {
    // Update the state
    setSelectedFile(event.target.files[0]);
    setOpen2(true);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function onFileUpload() {
    setIsSubmitting(true);
    // Create an object of formData
    const formData = new FormData();

    // Update the formData object
    formData.append("file", selectedFile, selectedFile.name);

    // Details of the uploaded file
    console.log(selectedFile);

    // Request made to the backend api
    // Send formData object

    const config = {
      headers: {
        Authorization: "state.auth.token",
      },
    };

    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone_number", phoneNumber);
    formData.append("description", description);
    formData.append("experience", experience);
    formData.append("job_id", jobId);

    axios
      .post(API_URL + "add_application", formData, config)
      .then(() => {
        setIsSubmitting(false);
        dispatch(alertMessage("SUCCESS", "SUCCESS", "Application submitted!"));
        setOpen2(false);
      })
      .catch((err) => {
        dispatch(alertMessage("ERROR", "ERROR", "An Error Occured."));
        setOpen2(false);
      });

    setOpen(false);
    document.getElementById("contained-button-file").value = "";
  }

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              marginTop: "2.2vh",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen2(false)}
                style={{
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                }}
              />
            </IconButton>
          </div>
          <h2>File Details:</h2>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  dispatch(
                    alertMessage(
                      "ERROR",
                      "File too big.",
                      "File size should be less than 25 MB."
                    )
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD and SUBMIT
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{
                  width: "100%",
                  fontSize: "15px",
                  height: "35px",
                  backgroundColor: themeStyle.primaryColor,
                }}
              >
                <PublishIcon />
                &nbsp;&nbsp;UPLOAD and SUBMIT
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open2}
          onClose={() => setOpen(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open2}>
            <div
              style={{
                position: "absolute",
                top: "50%",
                backgroundColor: themeStyle.backgroundColor,
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                padding: "2.2vh",
              }}
            >
              {fileData()}
            </div>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div
              style={{
                borderRadius: "25px",
                position: "absolute",
                top: "50%",
                backgroundColor: "white",
                left: "50%",
                padding: "2.2vh",
                transform: state.auth.isMobile
                  ? "scale(0.8) translate(-62.5%, -62.5%)"
                  : "translate(-50%, -50%)",
                width: state.auth.isMobile ? "100vw" : "40vw",
              }}
            >
              <h2 style={{ marginBottom: "2.2vh", textAlign: "center" }}>
                Apply for {jobName}
              </h2>
              <form style={{ padding: "15px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="name"
                      autoComplete="name"
                      autoFocus
                      placeholder="Name *"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="phonenumber"
                      autoComplete="phonenumber"
                      autoFocus
                      placeholder="Phone number *"
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                      }}
                    />
                  </Grid>
                </Grid>

                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid " + themeStyle.primaryColor,
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  placeholder="E-mail *"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    height: "400",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid " + themeStyle.primaryColor,
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="description"
                  autoComplete="description"
                  autoFocus
                  placeholder="Work history (Years and Company)"
                  value={experience}
                  onChange={(e) => {
                    setExperience(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    height: "400",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid " + themeStyle.primaryColor,
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="description"
                  autoComplete="description"
                  multiline
                  rows={4}
                  autoFocus
                  placeholder="Description of your past projects/current position *"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: { navColor: "#444", navOpacity: 1 },
                    });
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2.2vh",
                  }}
                >
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file"
                      type="file"
                      onChange={(e) => onFileChange(e)}
                    />

                    <Button
                      style={{
                        width: "100%",
                        fontSize: "15px",
                        height: "55px",
                        textAlign: "center",
                        backgroundColor: themeStyle.primaryColor,
                      }}
                      variant="contained"
                      component="span"
                    >
                      <h4>Upload Resume and Submit Application</h4>
                    </Button>
                  </label>
                </div>
              </form>
            </div>
          </Fade>
        </Modal>

        <div className="anigrad">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "85vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile ? "-6vh" : "0px",
                  fontSize: state.auth.isMobile ? "35px" : "8.75vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                {"Careers at "}
                <span
                  style={{
                    color: "yellow",
                  }}
                >
                  Riches Media Digital
                </span>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "4.4vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                Transforming businesses through technology.
              </div>
            </div>
          </div>
        </div>
        <ContentSideBySideInv
          title="Why Work with Us?"
          subtitle={
            <ul style={{ marginLeft: "-40px" }}>
              <strong>Cutting-Edge Skill Development:</strong> Gain hands-on
              experience with advanced tools and technologies, enhancing your
              technical expertise and marketability.
              <br />
              <br />
              <strong>Creative and Innovative Projects:</strong> Work on
              diverse, high-impact projects that allow you to showcase and
              expand your creativity.
              <br />
              <br />
              <strong>Professional Growth Opportunities:</strong> Access to
              training, workshops, and mentorship to stay ahead in the
              competitive CG industry.
            </ul>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/webdesign.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <OurProcess
          invert
          step1={"Define Your Career Goals and Growth Path"}
          step1description={
            "We start by understanding your career aspirations and aligning them with opportunities within our organization. Whether you're looking to grow as a developer, designer, or leader, we help you define clear goals and create a personalized growth plan. Our mentorship programs and career development workshops ensure you have the support you need to succeed."
          }
          step2={"Collaborate and Innovate in a Dynamic Environment"}
          step2description={
            "Join a team that values collaboration and innovation. Work alongside talented professionals on cutting-edge projects that challenge and inspire you. Our open and inclusive culture encourages creativity, knowledge sharing, and out-of-the-box thinking, helping you grow both personally and professionally."
          }
          step3={"Access Learning and Development Opportunities"}
          step3description={
            "We invest in your growth by providing access to training programs, certifications, and workshops. Whether you want to learn a new technology, improve your leadership skills, or stay ahead in your field, we offer the resources and support to help you achieve your goals. Continuous learning is at the heart of our culture."
          }
          step4={"Thrive in a Supportive and Inclusive Workplace"}
          step4description={
            "At our company, we celebrate diversity and foster an inclusive environment where everyone feels valued and respected. From flexible work policies to wellness programs, we prioritize your well-being and work-life balance. Join us and be part of a workplace that empowers you to thrive and make a meaningful impact."
          }
        />
        <div
          style={{
            paddingTop: "6vh",
            paddingBottom: "100px",
            backgroundColor: "white",
          }}
        >
          <TabContext value={value}>
            {!state.auth.isMobile ? (
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  background: "white",
                  maxWidth: "100vw",
                }}
              >
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Growth"
                    value="1"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Work-Life Balance"
                    value="2"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Innovative Culture"
                    value="3"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Learning "
                    value="4"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Inclusive Environment"
                    value="5"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                </TabList>
              </Box>
            ) : (
              <div style={{ marginBottom: "-100px" }} />
            )}
            <TabPanel value="1">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                titleFontSize={state.auth.isMobile ? "26px" : "32px"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Unlock Your Potential"
                subtitle="At our company, we believe in nurturing talent and providing clear career progression paths. Whether you're starting your career or looking to take the next step, we offer mentorship programs, leadership training, and opportunities to work on cutting-edge projects. Grow with us and achieve your professional goals while making a meaningful impact."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    alt={"Digital Marketing Career"}
                    src={
                      "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="2">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Achieve Work-Life Balance with Flexible Policies"
                subtitle="We understand the importance of balancing work and personal life. Enjoy flexible working hours, remote work options, and generous paid time off. Our supportive policies ensure you can thrive both professionally and personally, making your time with us fulfilling and stress-free."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="3">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                subtitleColor={"#222"}
                title="Be Part of an Innovative and Collaborative Culture"
                subtitle="Join a team that values creativity, collaboration, and innovation. We encourage out-of-the-box thinking and provide the tools and resources you need to bring your ideas to life. Work alongside talented professionals in a dynamic environment where your contributions matter."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1559136656-3db4bf6c35f8?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="4">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Continuous Learning and Professional Development"
                subtitle="We invest in your growth by offering access to training programs, workshops, and certifications. Stay ahead in your field with opportunities to learn new skills and technologies. Our commitment to your development ensures you’re always growing and evolving in your career."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="5">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                subtitleFontSize={state.auth.isMobile ? "1.8vh" : "2.2vh"}
                title="Join an Inclusive and Diverse Workplace"
                subtitle="We celebrate diversity and are committed to creating an inclusive environment where everyone feels valued and respected. Our team is made up of individuals from different backgrounds, cultures, and perspectives, fostering a rich and collaborative workplace culture."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1560264280-88b68371db39?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
          </TabContext>
        </div>
        <div
          className="anigrad"
          style={{
            width: "100%",
            padding: state.auth.isMobile ? "10px" : "6vh",
          }}
        >
          <div
            style={{
              borderRadius: "25px",
              fontSize: state.auth.isMobile ? "30px" : "4.4vh",
              color: "white",
              fontWeight: 600,
              paddingTop: "6vh",
            }}
          >
            Benefits of Joining Us
          </div>
          <div
            style={{
              borderRadius: "25px",
              fontSize: "22px",
              color: "white",
              paddingTop: "2.2vh",
            }}
          >
            We are an equal opportunity employer and make employment decisions
            based on merit. We aim to have the best people in every job. Our
            policy prohibits unlawful discrimination based on race.
          </div>
          <div style={{ height: "6vh" }} />
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Grid
              style={{
                width: state.auth.isMobile ? "100%" : "70%",
                display: "flex",
                justifyContent: "center",
              }}
              container
              spacing={3}
            >
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <FeatureCardSmall
                  title={"Remote or Office Work"}
                  text={""}
                  icon={
                    <CellTowerIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Flexible Hours"}
                  text={""}
                  icon={
                    <SupportAgentIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Professional Development"}
                  text={""}
                  icon={
                    <AttachMoneyIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>

              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Career Growth"}
                  text={""}
                  icon={
                    <WorkIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
            </Grid>
          </div>
          <div style={{ height: "6vh" }} />

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Grid
              style={{
                width: state.auth.isMobile ? "100%" : "70%",
                display: "flex",
                justifyContent: "center",
              }}
              container
              spacing={3}
            >
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <FeatureCardSmall
                  title={"Recognition and Rewards"}
                  text={""}
                  icon={
                    <HealthAndSafetyIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Team Activities"}
                  text={""}
                  icon={
                    <AccountBalanceIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Parental Leave"}
                  text={""}
                  icon={
                    <AutoGraphIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Health Benefits"}
                  text={""}
                  icon={
                    <CorporateFareIcon
                      style={{
                        fontSize: state.auth.isMobile ? "25px" : "6vh",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
            </Grid>
          </div>

          <div style={{ height: "6vh" }} />
        </div>

        <div
          style={{
            fontSize: state.auth.isMobile ? "30px" : "4.4vh",
            color: themeStyle.primaryColor,
            fontWeight: 600,
            backgroundColor: "white",
            paddingBottom: "6vh",
            paddingTop: "6vh",
          }}
        >
          Current Openings
        </div>
        {state.auth.isMobile ? (
          <Grid
            container
            style={{ backgroundColor: "white", paddingBottom: "10vh" }}
          >
            <Grid item xs={0} sm={0} md={2} lg={2} xl={2}></Grid>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <Grid container spacing={5}>
                {vacancies.map((vacancy, index) => (
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "start",
                      minHeight: "50vh",
                    }}
                  >
                    <div
                      className="anigrad"
                      style={{
                        color: "white",
                        minHeight: "36vh",
                        padding: "2.2vh",
                        paddingTop: "15px",
                        borderRadius: "10px",
                        width: state.auth.isMobile ? "90%" : "100%",
                        backgroundColor: "white",
                        boxShadow:
                          "0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19)",
                        justifyContent: "flex-start",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        display: "flex",
                        marginLeft: state.auth.isMobile ? "2.2vh" : "0px",
                      }}
                    >
                      <PersonSearchIcon
                        style={{
                          fontSize: "100px",
                          color: "white",
                          marginRight: "15px",
                        }}
                      />
                      <div>
                        <div
                          style={{
                            display: "flex",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "3.6vh",
                            marginTop: "15px",
                          }}
                        >
                          {vacancy.name}
                        </div>
                        <div
                          className="trust a"
                          style={{
                            margin: "15px 0px 15px 0px",
                            width: "60px",
                            height: "3px",
                            backgroundColor: "white",
                          }}
                        ></div>
                        <div
                          style={{
                            fontSize: "1.8vh",
                            fontWeight: 600,
                            color: "white",
                          }}
                        >
                          {vacancy.location}
                        </div>
                        <br />
                        {vacancy.description}
                      </div>
                      <br />
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button
                          style={{ marginTop: "6vh", filter: "invert(0)" }}
                          onClick={() => {
                            setJobName(vacancy.name);
                            setJobLink(vacancy.link);
                            setJobId(vacancy.id);
                            setOpen(true);
                          }}
                          className="squishy"
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={0} sm={0} md={2} lg={2} xl={2}></Grid>
          </Grid>
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "white",
              paddingBottom: "100px",
            }}
          >
            <TableContainer
              component={Paper}
              style={{ width: state.auth.isMobile ? "100%" : "80%" }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 600 }}>Position</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Location</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>
                      Experience
                    </TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Skill Set</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Apply</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {vacancies.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ fontSize: "18px" }}>
                        {row.name}
                      </TableCell>
                      <TableCell style={{ fontSize: "18px" }}>
                        {row.location}
                      </TableCell>
                      <TableCell style={{ fontSize: "18px" }}>
                        {row.experience}
                      </TableCell>
                      <TableCell style={{ fontSize: "18px" }}>
                        {row.skillset}
                      </TableCell>
                      <TableCell>
                        {" "}
                        <Button
                          onClick={() => {
                            setJobName(row.name);
                            setJobLink(row.link);
                            setJobId(row.id);
                            setOpen(true);
                          }}
                          style={{
                            width: "100%",
                            height: "35px",
                            fontSize: "18px",
                            backgroundColor: themeStyle.primaryColor,

                            color:
                              state.auth.theme == "dark"
                                ? themeStyleDark.primaryButtonTextColor
                                : themeStyle.primaryButtonTextColor,
                          }}
                          variant="contained"
                        >
                          <span style={{}}>Apply</span>
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Trust invert />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
